<template>
	<div class="bg-dark-mode">
		<HomeNav v-if="userNotLoggedin == true" />
		<header class="masthead mb-auto" v-if="userNotLoggedin == false">
			<nav class="navbar navbar-expand-lg">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoLogin"
						>
							login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="privacy-banner d-flex flex-column">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 col-lg-8 col-xl-8">
						<h3 class="my-5 font-semibold">IBAKATV Terms of Use</h3>
					</div>
				</div>
			</div>
			<div class="page-icon bg-primary">
				<img src="../assets/img/Outline.svg" alt="" />
			</div>
		</section>
		<section class="bg-cookies-container">
			<div class="container tab-pane fade show active" id="mediacenter">
				<div class="row justify-content-center">
					<div class="col-md-8 col-lg-8 col-xl-8 mb-5">
						<p class="mt-4">
							Welcome to ibakatv.com (the “Site”), owned and operated by iBAKA
							Entertainment Inc. (IEI” “we”). We are a company registered in the
							U.S.A (with Company Number 4405534-2) and in Nigeria (with Company
							Number 1016458), having our corporate office situate at 5701
							Shingle Creek Parkway, suit 420A Brooklyn Center, MN 55430,
							Minnesota U.S.A and our operational office situate at No. 688c,
							Jacob Nwakolo Close, Off Odujinrin Avenue, Omole Phase 2, Lagos
							State, Nigeria. We are a subscription service that provides our
							members (“you” “yourself” “Users”) with access to content
							including but not limited to access to motion pictures, television
							and other audio-visual entertainment (“content”) delivered over
							the Internet, to Internet enabled devices. These Terms of Use,
							including our Privacy Policy (the “Terms”) govern your use of our
							service. As used in these Terms of Use, “iBAKATV service”,
							“iBAKATV PLUS”, “iBAKATV+”, “our service”, or “service” means the
							subscription service provided by IEI for discovering and watching
							the content, including all features and functionality, the Site,
							content, user interface and software associated with our service.
						</p>
						<p>
							<span class="font-semibold">1.1. Acceptance of Terms of Use</span>
							<br />
							By accessing, visiting, using or browsing the iBAKATV service, via
							this Site or any other device or other technology, you accept and
							agree to be bound by the Terms. Please read carefully. Further,
							you shall be subject to any posted guidelines or rules applicable
							to our service, which may be posted and modified from time to
							time. All such guidelines are hereby incorporated by reference
							into the Terms. ANY ACCESS, USE OR PARTICIPATION IN THE iBAKATV
							SERVICE WILL CONSITUTE ACCEPTANCE OF THE TERMS. IF YOU DO NOT
							AGREE TO THESE TERMS OF USE, PLEASE DO NOT USE THE iBAKATV SERVICE
							OR OUR SITE OR ACCESS OUR SERVICE.
						</p>
						<p>
							<span class="font-semibold"> 1.2. Changes to Terms of Use</span>
							<br />
							IEI may in its sole discretion, from time to time, change these
							Terms, at any time without notice. We will display the changes on
							this page of the Site and such changes shall be effective
							immediately.
						</p>
						<p>
							<span class="font-semibold"> 2. Privacy</span> <br />
							Please read our privacy policy here
							<a href="https://ibakatv.com/privacy" target="_blank" class="link"
								>https://ibakatv.com/privacy</a
							>
							which also governs your use of the Site and our service, to
							understand our practices.
						</p>
						<p>
							<span class="font-semibold"> 3. Communications </span> <br />
							By using the iBAKATV service, you consent to receiving electronic
							communication from iBAKATV and IEI relating to your account. We
							will communicate with you by e-mail, or by posting notices on the
							Site or through other iBAKATV methods. For contractual purposes,
							you consent to receive communications from us electronically and
							you agree that all agreements, notices, disclosures and other
							communications that we provide you electronically satisfy any
							legal requirement that such communication be in writing. You also
							consent to receiving certain other communication from us, such as
							newsletters, special offers, questionnaires, customer surveys or
							other announcements via email or other methods. You may opt out of
							receiving non-transactional communications, including marketing
							communications from us by following the directions in our e-mail
							to “unsubscribe” from our mailing list, or by sending an e-mail
							request to support@ibakatv.com. Please be aware that if you chose
							not to receive such communication, certain offers attached to
							services you have chosen may be affected. We will still
							communicate with you in connection with transactional
							communications, including but not limited to servicing your
							account, invoices and customer services. Please review our privacy
							policy here https://ibakatv.com/privacy, for other choices with
							regards to opting out of cookies and interest based advertising
							from third party advertising agencies.
						</p>
						<p>
							<span class="font-semibold"> 4.1. iBAKATV Service</span> <br />
							In order to access our service, you will have to create an account
							with iBAKATV either by formally registering with iBAKATV or a
							third party such as Facebook Nigeria ("Facebook"). You must be 18
							years of age, or the age of majority in your province, territory
							or country, to become a member of the iBAKATV service. Individuals
							under the age of 18, or applicable age of majority, may utilize
							the service only with the involvement of a parent or legal
							guardian, under such person's account and otherwise subject to
							these Terms.
						</p>
						<p>
							Our service may allow you to: Access content on a temporary
							download basis for a limited period of time. Access content on a
							subscription basis for streaming over a limited period of time
							during the subscription period. A combination of temporary
							downloads and streaming. This may depend on your geographic
							location. Subject to your compliance with these Terms and your
							payment of any applicable fees, IEI or its content providers grant
							you a limited, revocable, non-exclusive, non- transferable,
							non-sub licensable license to access and make personal and
							non-commercial use of iBAKATV service (each a “License”):
						</p>
						<p>
							To stream Site content. If the Site includes a “Download” link
							next to the content, the License to download a single copy of such
							content to a device or other permitted device only on a temporary
							download basis for a limited period of time. Except for the
							foregoing limited license, no right, title or interest shall be
							transferred to you. You may view content through the iBAKA service
							only in geographic locations where we have licensed such content.
							The content that may be available to watch will vary by geographic
							location. IEI will use technologies to verify your geographic
							location. THE NUMBER OF DEVICES ON WHICH YOU MAY SIMULTANEOUSLY
							WATCH IS LIMITED. The number of devices available for use and the
							simultaneous streams may change from time to time at our
							discretion. The quality of the display of the content may vary
							from computer to computer, and device to device, and may be
							affected by a variety of factors, such as your location, your
							device, the bandwidth available through and/or speed of your
							Internet connection. You are responsible for all Internet access
							charges. Please check with your Internet provider for information
							on possible Internet data usage charges. iBAKATV makes no
							representations or warranties about the quality of your watching
							experience on your device. The time it takes to begin watching
							content will vary based on a number of factors, including your
							location, available bandwidth at the time, the movie or TV show or
							other audiovisual entertainment you have selected and the
							configuration of your viewing device. We continually update the
							iBAKATV service, including the content library, delivery methods
							and pricing. And we may add or remove content from our Service, or
							change the basis on which the content is available on the service.
							We reserve the right in our sole and absolute discretion to make
							changes from time to time and without notice in how we offer and
							operate our service.
						</p>
						<p>
							<span class="font-semibold">4.2. Restrictions </span> <br />
							You agree to use the iBAKATV service, including all features and
							functionalities associated therewith, in accordance with all
							applicable laws, rules and regulations, including public
							performance limitations or other restrictions on use of the
							service or content therein. In addition, you agree that: You are
							prohibited from reproducing, modifying, copying, uploading,
							exporting, transferring, selling, forwarding or transmitting the
							Contents on the Site other than in accordance with the license
							granted and further not to reproduce any information of the Site
							on any other website. You may not either directly or through the
							use of any device, software, internet site, web-based service, or
							other means remove, alter, bypass, avoid, interfere with, or
							circumvent any copyright, trademark, or other proprietary notices
							marked on the content or any digital rights management mechanism,
							device, or other content protection or access control measure
							associated with the content including geo-filtering mechanisms.
							You may not either directly or through the use of any device,
							software, internet site, web-based service, or other download,
							stream, (except as explicitly authorized in these Terms) copy,
							capture, reproduce, duplicate, archive, distribute, upload,
							publish, modify, translate, broadcast, perform, display, sell,
							transmit or retransmit the content unless expressly permitted by
							IEI in writing. You may not incorporate the content into, or
							stream or retransmit the content via, any hardware or software
							application or make it available via frames or in-line links
							unless expressly permitted by IEI in writing. Furthermore, you may
							not create, recreate, distribute or advertise an index of any
							significant portion of the content unless authorized by IEI. You
							may not circumvent, remove, alter, deactivate, degrade or thwart
							any of the content protections in the iBAKATV service; use any
							robot, spider, scraper or other automated means to access the
							iBAKATV service; decompile, reverse engineer or disassemble any
							software or other products or processes accessible through the
							iBAKATV service; insert any code or product or manipulate the
							content of the iBAKATV service in any way; or, use any data
							mining, data gathering or extraction method. You shall not upload
							post, e-mail or otherwise send or transmit any material designed
							to interrupt, destroy or limit the functionality of any computer
							software or hardware or telecommunications equipment associated
							with the iBAKATV service, including any software viruses or any
							other computer code, files or programs. You may not build a
							business utilizing the content, whether or not for profit. The
							content covered by these restrictions includes without limitation,
							any text, graphics, layout, interface, logos, photographs, audio
							and video materials, and stills. In addition, You are strictly
							prohibited from creating derivative works or materials that
							otherwise are derived from or based on in any way the content,
							including montages, mash-ups and similar videos, wallpaper,
							desktop themes, greeting cards, and merchandise, unless it is
							expressly permitted by IEI in writing. This prohibition applies
							even if you intend to give away the derivative materials free of
							charge. You may not arrange for any other website to be connected
							to the Site by way of hyperlink or otherwise without the prior
							written consent of IEI. You may not modify, enhance, remove,
							interfere with, or otherwise alter in any way any portion of the
							Video Player, its underlying technology, any digital rights
							management mechanism, device, or other content protection or
							access control measure incorporated into the Video Player. This
							restriction includes, without limitation, disabling, reverse
							engineering, modifying, interfering with or otherwise
							circumventing the Video Player in any manner that enables You to
							view the content without: Displaying visibly both the Video Player
							and all surrounding elements (including the graphical user
							interface, any advertising, copyright notices, watermarks and
							trademarks) of the webpage where the Video Player is located.
							Having full access to all functionality of the Video Player,
							including, without limitation, all video quality and display
							functionality and all interactive, elective, or click-through
							advertising functionality.
						</p>
						<p>
							<span class="font-semibold">
								5. Subscription, Billing, Renewal and Cancellation</span
							><br />
							<span class="font-semibold">
								5.1. Subscription Reoccurring Subscription:</span
							>
							Your iBAKATV subscription, will commence from month-to-month, or
							according to your chosen subscription plan “Subscription Period”
							as currently available on the Site (subject to a few exceptions,
							such as Payments by direct bank and cash payments), unless and
							until you cancel your subscription or we terminate or discontinue
							it. You must cancel your subscription before it renews each
							Subscription Period in order to avoid billing of the next
							subscription to your credit card or other payment method (“Payment
							Method”). Differing Subscription Plans: We may offer a number of
							subscription plans, including special promotional plans with
							differing conditions and limitations. You can find specific
							details regarding your subscription plan with IEI by visiting the
							Site and clicking on “Your Profile” page on the Site. We reserve
							the right to modify, terminate or otherwise amend our offered
							subscription plans.
						</p>
						<p>
							<span class="font-semibold">5.2. Billing</span> <br />
							By signing up for your iBAKATV subscription, you are expressly
							agreeing that we are authorized to charge you a subscription fee
							at the then current rate, every one (1) month, three (3) months,
							six (6) months, or twelve (12) months (“Subscription Period”)
							depending on your subscription plan, in addition to any other fees
							or charges you may incur in connection with your use of the
							iBAKATV service, including any applicable taxes to the Payment
							Method accepted by IEI. You acknowledge that the amount billed
							during each Subscription Period may vary for reasons that include
							promotional offers, changes in your Subscription plan, or changes
							in any applicable taxes and you authorize IEI to charge your
							Payment Method for the corresponding amounts.
						</p>
						<p>
							<span class="font-semibold"> 5.3. Reoccurring billing</span>
							<br />
							We automatically bill your Payment Method on the calendar day
							corresponding to the commencement of your Subscription Period and
							each Subscription Period thereafter (subject to a few exceptions,
							such as Payments by direct bank and cash payments) unless and
							until you cancel your subscription. By way of example, if you
							became a paying subscriber on July 1, for a one-month subscription
							plan, your Payment Method would next be billed on August 1. Also,
							if you became a paying subscriber on June 1, for a 6-month
							subscription plan, your Payment Method would next be billed on
							January 1. Subscription fees are fully earned upon payment. We
							reserve the right to change the timing of our billing. In the
							event your Subscription Period begins on a day not contained in a
							given month, we may bill your Payment Method on a day in the
							applicable month or Subscription Period or such other day, as we
							deem appropriate. As used in these Terms, "Billing" shall indicate
							either a charge or debit, as applicable, against your Payment
							Method.
						</p>
						<p>
							<span class="font-semibold"> 5.4. Billing Cycle</span> <br />
							The subscription fee will be billed at the beginning of your
							Subscription Period, and on each Subscription Period renewed
							thereafter unless and until you cancel your subscription or the
							account or service is otherwise suspended, terminated or
							discontinued pursuant to these Terms. To see the commencement date
							for your next billing cycle or renewal period, go to the Status
							section on “Your Profile” page on the Site. Alternatively, you may
							refer to your email invoice confirming your subscription from
							support@ibakatv.com. However, if you change your Payment Method,
							this could result in changing the calendar day upon which you are
							billed.
						</p>
						<p>
							<span class="font-semibold"> 5.5. Automatic Renewal </span> <br />
							If your Payment Method expires and you do not edit your Payment
							Method information or cancel your account, your service will
							automatically renew without prior notice to you, using the details
							of your previous payment. You must cancel your service before it
							renews in order to avoid us billing your account. However, where
							there are insufficient funds in your account, your account access
							would be terminated following several attempts to renew your
							subscription and communicate the issue to you.
						</p>
						<p>
							<span class="font-semibold"> 5.6. Payment Methods </span> <br />
							Payments can be made via credit card, or via any other payment
							method accepted by iBAKATV ("Payment Method") or the payment
							method you provided during registration. If you want to use a
							different Payment Method than the one you signed up for during
							registration, or if there is a change in your credit card validity
							or expiration date, you may edit your Payment Method information
							by clicking on "Your Profile" at the top right of your window and
							selecting “Update card details”. Alternatively, you can send an
							email to support@ibakatv.com requesting a secure, personalized
							link to update your payment information. If you subscribe with
							PayPal, updates can be made via the PayPal website. 5.7. No
							Refunds All fees and charges are non-refundable including refunds
							for partial months and content not watched. Very rarely, if there
							are special circumstances where iBAKATV determines it is
							appropriate (i.e., where the iBAKATV service is unavailable for
							days due to technical difficulties), we may provide credits to
							affected subscribers. The amount and form of such credits, and the
							decision to provide them, are at iBAKATV's sole and absolute
							discretion, and the provision of credits in one instance does not
							entitle anyone to credits in the future under similar or different
							circumstances. However, where on very rare occasions subscribers
							experience multiple debits due to technical malfunctions or
							errors; IEI shall refund such credits within 72 hours from
							complaint date.
						</p>
						<p>
							<span class="font-semibold"> 5.8. Card Protection</span> <br />
							Ensuring the protection of your card and access password is your
							(users) responsibility. If your credit card or instrument of
							payment is lost, stolen, or your password becomes compromised one
							way or the other, you are to immediately alert your bank/payment
							platform to prevent unauthorized usage of your card or instrument
							of payment. IEI will therefore not be liable for any such
							unauthorized use of your subscription and will not be liable to
							refund any such subscription payment.
						</p>
						<p>
							<span class="font-semibold">
								5.9. Cancelling your subscription
							</span>
							<br />
							You can view details on how to cancel your account via your
							iBAKATV Profile page. Alternatively, you can send an email to
							support@ibakatv.com requesting that we cancel your account. You
							must cancel your subscription 72 hours before it renews each
							Subscription Period in order to avoid the next Subscription
							Period’s billing. You can cancel your iBAKATV subscription at
							anytime. However note that WE DO NOT OFFER REFUNDS FOR PARTIAL
							MONTHS. If you cancel your subscription prior to the allotted
							expiration, you will continue to have access to iBAKATV for the
							remainder of your Subscription Period. To cancel, please click on
							"Your Profile" at the top right of your Profile window on the
							Site, and select Cancel Subscription option. Alternatively, if
							that option is not available on your account, you can send an
							email to support@ibakatv.com with "cancellation" written in the
							subject line and your username (at the top right of the Profile
							window) and your email address in the body of the email. If you
							have subscribed with PayPal, and wish to cancel your subscription,
							you will need to do so through PayPal.com. Also, you may request
							information on how to cancel via PayPal, by sending an email to
							support@ibakatv.com or using the chat window to the bottom right
							of the “Your Profile” window.
						</p>
						<p>
							<span class="font-semibold">5.10. Price changes</span> <br />
							We reserve the right to adjust pricing for our service or any
							components thereof, including pricing for subscription plans, in
							any manner and at any time as we may determine in our sole and
							absolute discretion.
						</p>
						<p>
							<span class="font-semibold">5.11.Subscription Bonus</span> <br />
							14 days extra will be added to all first time subscribers.
						</p>
						<p>
							<span class="font-semibold"> 6. Password and Account Access</span>
							<br />
							You must provide accurate and complete information when creating
							an account during Registration. You may check, following
							subscription help instructions to determine whether your
							information is correct and accurate, and if not, to correct or
							update your registration data. You are responsible for all uses of
							your password. You agree not to assign, transfer; sublicense your
							rights as a user to the Site. If IEI determines, or has reasonable
							grounds to believe in its sole discretion that information you
							provided is inaccurate, incomplete, misleading or designed to
							deceive, IEI reserves the right to immediately suspend or
							terminate your account, with or without notice to you, and without
							refund of any sums you have paid as a subscriber, and refuse to
							grant any and all current or future access to use of the Services,
							and any benefit to which you may be entitled through your access
							and use of the Site. You agree to promptly update your
							information, following subscription help instructions, in the
							event of any known or suspected unauthorized use of your
							subscription, or any known breach of security including loss,
							theft, or unauthorized disclosure of your password. In the event
							of a breach of security, you will remain liable for any
							unauthorized use of your subscription until you update your
							information and for any losses IEI suffers due to the unauthorized
							use of your account.
						</p>
						<p>
							<span class="font-semibold">7. User Material</span> <br />
							The iBAKATV service may enable you to submit comment, information
							or reviews to the iBAKATV service, (“User Material”), and such
							User Material will generally be available to all Users of the
							iBAKATV service. User Materials do not include account information
							you provide when you register as a Member or when you subsequently
							change that information. IEI does not endorse any User Material,
							and any User Materials on the iBAKATV service do not reflect the
							opinions or policies of IEI. We do not necessarily review User
							Material submitted by Users or You. We are not responsible for the
							content of User Material. We make no warranties or
							representations, express or implied, about User Material,
							including as to its legality or accuracy. We disclaim all
							liability in connection with User Material to the extent permitted
							by law. We reserve the right (but not the obligation) in our sole
							discretion, to refuse to post or to remove or edit any of your
							User Material, or the right in our sole discretion, to restrict,
							suspend, or terminate your access to all or any part of the
							iBAKATV service, where User Material breaches the provisions of
							this section on User Material without notice to you. When you
							provide IEI with, or submit User Material, including any other
							material contained in any communication you may send to us,
							including responses to questionnaires, to the Site or as part of
							your use or access of the iBAKATV service, you grant IEI, its
							subsidiaries and affiliates, an irrevocable, perpetual,
							non-exclusive, royalty-free, sub licensable, transferable and
							worldwide license to use, reproduce, modify, distribute, store,
							prepare derivative works of, display and publicly perform that
							User Material in any media now known or hereinafter created. You
							further grant IEI the right to grant permissions to users of the
							Site to view such information for personal and non-commercial use.
							You agree that you shall immediately notify IEI of any
							objectionable posts or other content appearing on the Site. You
							acknowledge and agree that IEI is free to use any User Material
							and that you have no expectation of compensation or
							confidentiality of any nature with respect to any User Material.
							Each time you submit User Material to us, you represent and
							warrant to us as follows: You own your User Material or have the
							right to submit it, and in submitting it you will not be
							infringing any rights of any third party, including intellectual
							property rights (such as copyright or trade mark), privacy or
							publicity rights, rights of confidentiality or rights under
							contract or cause injury to any person or entity; The content is
							accurate. Your User Material is not illegal, obscene, defamatory,
							threatening, pornographic, harassing, hateful, racially or
							ethnically offensive, or otherwise objectionable, or encourages
							conduct that would be considered a criminal offense, give rise to
							civil liability, violate any law, or otherwise inappropriate. In
							submitting your User Material you are not impersonating any other
							person. You agree to pay for all royalties, fees and other
							payments owed to any person by reason of your posting User
							Material. You will indemnify IEI for all claims resulting from the
							User Material you submit. You may encounter third party
							applications that interact with the iBAKATV service or features
							that allow you to use third party applications or services,
							including Facebook and Twitter. These applications or services may
							import date related to your iBAKATV account and activity and
							otherwise gather data from you. You acknowledge and agree that IEI
							is not responsible for User Material you share with or through
							third party applications or services.
						</p>
						<p>
							SUCH APPLICATIONS AND SERVICES ARE OWNED OR OPERATED BY THIRD
							PARTIES THAT ARE NOT RELATED TO OR SPONSORED BY IEI. USE OF A
							THIRD PARTY APPLICATION OR SERVICE IS AT YOUR OWN OPTION AND RISK.
						</p>

						<p>
							8. Intellectual Property "Intellectual Property" in this context
							means copyrights, database rights, trademarks, trade names, domain
							names, rights in logos, get-up and content, inventions, trade
							secrets and know-how, patents, all rights of whatever nature in
							computer software and data, all rights of privacy and all
							intangible rights and privileges of a nature similar to any of the
							above, in every case in any part of the world and whether or not
							registered; and including all granted or pending registrations,
							and all rights to make applications for registration in respect of
							any of the same.
						</p>
						<p>
							8.1. Copyright The iBAKATV service, including all content provided
							on the iBAKATV Service is the property of IEI or its licensors and
							is protected by Nigerian and international copyright, trade secret
							or other intellectual property laws and treaties.
						</p>

						<p>
							8.2. Trademark iBAKATV is a registered trademark of IEI. iBAKATV’s
							trademark and trade dress may not be used in connection with any
							product or service that is not IEI’s, in any manner that is likely
							to cause confusion among clients or in any manner that disparages
							or discredits IEI. All other trademarks not owned by IEI that
							appear in any iBAKATV service are the property of their respective
							owners, who may or may not be affiliated with, connected to, or
							sponsored by iBAKATV.
						</p>

						<p>
							8.3. Patents You may not extract and/or re-utilise parts of the
							content of any iBAKATV service without our express written
							consent. In particular, you may not utilize any date mining,
							robots, or similar data gathering and extraction tools to extract
							(whether once or many times) for re-utilization any substantial
							parts of the content of any iBAKATV service, without our express
							written consent. You may also not create and/or publish your own
							database that features substantial parts of any iBAKATV service
							without our express written consent.
						</p>

						<p>
							8.4. Copyright Infringement iBAKATV respects the intellectual
							property of others. If you believe your work has been used in a
							way that gives rise to concerns of infringement, please notify us
							using the procedure below for making infringement claims.
						</p>

						<p>
							8.5. Notice and Procedure for Claims of Copyright Infringement If
							you are a Copyright Owner or an Agent asserting that any of the
							content on the Site infringes upon your copyrights, you may submit
							a notification by making available the following information to us
							or our Copyright Agent in writing in accordance with the procedure
							set forth below. We will process and take appropriate action in
							accordance with applicable intellectual property laws.
						</p>

						<p>Your notification must contain the following:</p>
						<p>
							A notification in writing duly executed by a physical or
							electronic signature of a person authorized to act on behalf of
							the owner of an exclusive right that is allegedly infringed.
							Identification of the copyrighted work claimed to have been
							infringed, or, if multiple copyrighted works at a single online
							site are covered by a single notification, a representative list
							of such works at that site. Identification of the material that is
							claimed to be infringing or to be the subject of infringing
							activity and that is to be removed or access to which is to be
							disabled, and information reasonably sufficient to permit the
							service provider to locate the material. Information reasonably
							sufficient to permit the service provider to contact you, such as
							an address, telephone number, and, if available, an electronic
							mail address at which you may be contacted. A statement that you
							have in good faith, believed that use of the material in the
							manner complained of is not authorized by the copyright owner, its
							agent, or the law. A statement that the information in the
							notification is accurate, and under penalty of perjury, that you
							are authorized to act on behalf of the owner of an exclusive right
							that is allegedly infringed. A copy of your notification should be
							emailed to IEI’s copyright agent at copyright@ibakatv.com. (Please
							note that this contact address is only for copyright infringement
							claims; you will not receive a reply if the matter is not a
							copyright issue).
						</p>
						<p>
							9. Third Party Content/Links to Other Websites The Site may
							contain links to other websites or services that are not owned or
							controlled by IEI. You acknowledge that any access is at your sole
							discretion and risk. We do not review or endorse any of those
							websites or services. We are not responsible in any way for: Any
							errors or omissions in relation to other websites, services or
							contents on the websites. The privacy practices. The availability.
							The content, advertising, products, goods or other materials,
							services or resources on or available from. The use to which
							others make of; these websites or services. IEI DOES NOT WARRANT,
							ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY WEBSITE,
							PRODUCT OR SERVICES ADVERTISED ON, OR OFFERED BY A THIRD PARTY
							THROUGH THE SITE OR THE iBAKATV SERVICE, OR ANY HYPERLINKED
							SERVICES OR FEATURED IN ANY BANNER OR OTHER ADVERTISING. IEI WILL
							NOT BE RESPONSIBLE FOR ANY DAMAGE, LOSS OR OFFENCE CAUSED OR
							ALLEGED TO BE CAUSED BY, OR IN CONNECTION WITH, THE USE OR
							RELIANCE ON SUCH WEBSITES OR SERVICES.
						</p>
						<p>
							10. Termination, Modifications, Suspension We hope not to, but we
							may change, suspend, or discontinue - temporarily or permanently -
							some or all of the iBAKATV service (including the content and the
							devices through which the iBAKATV service is accessed), with
							respect to any or all Users, at any time without notice. You
							acknowledge that we may do so in IEI’s sole discretion. You also
							agree that IEI will not be liable to you for any modification,
							suspension, or discontinuance of the iBAKATV service, although if
							IEI suspends or discontinues the iBAKATV service, IEI may, in its
							sole discretion, provide you with a credit, refund, discount or
							other form of consideration. However, if IEI terminates your
							account or suspends or discontinues your access to iBAKATV service
							due to your violation of these Terms, or any applicable law, rule
							or regulation, or engaged in other inappropriate conduct, then you
							will not be eligible for any such credit, refund, discount or
							other consideration. In addition, IEI also reserves the right to
							terminate or cancel your access to the Site in whole or in part,
							without notice, with respect to any breach or threatened breach of
							any portion of these Terms, or any applicable law, rule or
							regulation, or your engagement in other inappropriate conduct. If,
							IEI terminates or cancels your access to the site based on the
							reasons in these Terms of Use above, IEI reserves the right to
							refuse to provide you with use, or access to its Site in the
							future. You acknowledge that IEI shall not be liable to you or any
							third party for termination of your access to this Site.
						</p>
						<p>
							11. Disclaimers of Warranties THE iBAKATV SERVICE AND ALL CONTENT
							AND SOFTWARE ASSOCIATED THEREWITH, OR ANY OTHER FEATURES OR
							FUNCTIONALITIES ASSOCIATIED WITH THE iBAKATV SERVICE, ARE PROVIDED
							“AS IS” AND “AS AVAILABLE” WITH ALL FAULTS AND WITHOUT
							REPRESENTATION OR WARRANTY OF ANY KIND. TO THE FULL EXTENT
							PERMISSIBLE BY APPLICABLE LAW, IEI, ITS SUBSIDARIES AND AFFILATES
							EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED,
							INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
							MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE OR USE, AND
							NON-INFRINGNMENT. IEI, ITS SUBSIDARIES AND AFFILIATES DO NOT
							GUARANTEE, REPRESENT, OR WARRANT THAT THE iBAKATV SERVICE,
							FEATURES, INFROMATION, CONTENT, MATERIALS, THE SITE, SOFTWARE OR
							OTHER SERVICES INCLUDED OR OTHERWISE MADE AVAILABLE TO YOU THROUGH
							THE iBAKATV SERVICE, OR ELECTRONIC COMMUNICATION SENT FROM IEI ARE
							UNINTERUPTED OR ERROR FREE; ARE FREE FROM OF ANY BUGS, VIRUSES,
							TROJAN HORSES OR OTHER HARMFUL COMPONENTS. YOU AGREE THAT YOUR USE
							OF THE SERVICES PROVIDED ON THIS SITE SHALL BE AT YOUR SOLE RISK.
							IEI MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
							COMPLETENESS OF THE iBAKATV SERVICE, OR THE CONTENT.
						</p>
						<p>
							12. Limitation and Exclusion of Liability TO THE EXTENT
							PERMISSIBLE UNDER APPLICABLE LAWS, IN NO EVENT SHALL IEI, OR ITS
							SUBSIDARIES OR AFFILIATES OR ANY OF THEIR SHAREHOLDERS, DIRECTORS,
							OFFICERS, EMPLOYEES, AGENTS OR LICENSORS BE LIABLE (JOINTLY OR
							SEVERALLY) TO YOU FOR PERSONAL INJURY OR ANY SPECIAL, INCIDENTAL,
							DIRECT, INDIRECT, PUNITIVE OR CONSEQUENTIAL DAMAGES OF ANY KIND,
							OR ANY DAMAGES WHATSOEVER ARISING FROM THE USE OF THE iBAKATV
							SERVICE, THE SITE, OR FROM ANY INFORMATION, CONTENT, MATERIALS,
							SERVICES, PRODUCTS INCLUDED OR MADE AVAILABLE TO YOU THOUGH ANY
							iBAKATV SERVICE. The Service is controlled and offered by IEI from
							its facilities. Those who access or use the Service from other
							jurisdictions do so at their own volition and are responsible for
							compliance with local laws.
						</p>
						<p>
							13. Exclusions and Limitations SOME JURISDICTIONS DO NOT ALLOW THE
							EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF
							LIABILITY FOR CERTAIN TYPES OF DAMAGES, THEREFORE SOME OF THE
							ABOVE LIMITATIONS IN LIMITATION AND EXCLUSION OF LIABILITY MAY NOT
							APPLY TO YOU. TO THE EXTENT IEI MAY NOT, AS A MATTER OF APPLICABLE
							LAW, DISCLAIM ANY WARRANTY OR LIMIT ITS LIABILITIES, THE SCOPE AND
							DURATION OF SUCH WARRANTY AND THE EXTENT OF IEI’S LIABILITY SHALL
							BE THE MINIMUM PERMITTED UNDER SUCH APPLICABLE LAWS.
						</p>
						<p>
							14. Indemnity You agree to indemnify, defend and hold harmless
							IEI, its subsidiaries, affiliates, successor, and each of its
							officers, directors, employees, advertising and promotion
							agencies, representatives or agents, including IEI’s distributors
							and licensors, (collectively the "Indemnified Parties") from and
							against any and all losses, liabilities, claims, obligations,
							damages, expenses or costs (including but not limited to
							attorney's fees) incurred by or made against any Indemnified Party
							arising from: Use of and access to the service. Violation of any
							of the Terms, policy or guidelines referred to herein. Violation
							of any third party right, including without limitation any
							Copyright, Property or Privacy right. Any claim that our Content
							caused damage to a third party. This defence and indemnification
							obligation will survive the Terms and use of the Services.
						</p>
						<p>
							15. Governing Law The Terms of Use of this Site is governed by and
							construed in accordance with the laws of Nigeria and the Courts in
							Nigeria shall have exclusive jurisdiction to determine any dispute
							in connection with the Terms of Use of our service.
						</p>
						<p>
							16. Customer Support If you have any questions concerning the use
							of the Site or these Terms, please contact iBAKATV customer
							service by sending an email request to support@ibakatv.com.
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style scoped>

</style>

<script>
import HomeNav from "@/components/HomeNav.vue";
export default {
	name: "mediaCenter",
	components: {
		HomeNav,
	},
	computed: {
		userNotLoggedin() {
			if( this.$store.state.user.logedin){
				return true
			} else{
				return false
			}
		},
	},
	created() {
		this.$store.commit("showdefaultFooter", true);
	},
	mounted() {
		window.scroll(0, 0);
	},

	methods: {
		gotoLogin() {
			this.$router.push("/login");
		},
		removeErr() {
			this.showresmsg = false;
		},
		ValidateEmail(mail) {
			var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (mail.match(mailformat)) {
				return true;
			} else {
				// alert("You have entered an invalid email address!");
				return false;
			}
		},
		contact() {
			this.isActive = true;
			self.showerr = false;
			if (this.docontact) {
				var DataToSend = {
					phone: "",
					email: this.email,
					description: this.msg,
					title: this.subject,
				};

				self = this;
				if (this.ValidateEmail(DataToSend.email)) {
					this.$store.dispatch("contactus", DataToSend).then((res) => {
						self.showresmsg = "Your email has been sent to site admin";
						self.showerr = true;
					});
				} else {
					self.showresmsg = "Invalid Email Entred";
					self.showerr = true;
				}
			}
		},
	},

	data() {
		return {
			isActive: false,
			docontact: true,
			userid: "",
			password: "",
			title: "",
			email: "",
			phno: "",
			subject: "",
			msg: "",
			showerr: false,
			showresmsg: "",
		};
	},
};
</script>
